export default "__VITE_ASSET__BsvWoHI0__"